const getPathname = (): string => window.location.pathname;

const getSearch = (): string => window.location.search;

const getHref = (): string => window.location.href;

const getHostname = (): string => window.location.hostname;

const setHref = (url: string): void => {
  window.location.href = url;
};

export { getPathname, getSearch, getHref, getHostname, setHref };
